module.exports = __webpack_public_path__ + "assets/e1bf82de6ac697728c205d79b88f0c61.mp4";